/* BROHN SMITH: hero slideshow (homepage slide one).
   Crossfades through whichever image set is showing (desktop or mobile).
   It holds still while the hero is scrolled away, while the tab is hidden,
   and for visitors who ask for reduced motion. It never fades to an image
   that has not finished loading, so a slow connection never shows black.
   An image can carry its own header colour (data-header-theme), for shots
   where the slide's colour would disappear, such as a red logo over a red
   flower. The header follows the image, and returns to the slide's own
   colour on images that do not set one. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function visibleSet(root) {
    var sets = root.querySelectorAll('[data-hero-set]');
    for (var i = 0; i < sets.length; i++) {
      if (window.getComputedStyle(sets[i]).display !== 'none') return sets[i];
    }
    return null;
  }

  function heroOnScreen(root) {
    var slide = root.closest('.swiper-slide');
    var deck = root.closest('[data-homepage-swiper]');
    // Before the deck is running (or on a page without one) treat it as showing.
    if (!slide || !deck || !deck.classList.contains('swiper-initialized')) return true;
    return slide.classList.contains('swiper-slide-active');
  }

  /* Same classes theme.js sets when the deck changes slide. */
  function paintHeader(theme) {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    header.classList.remove('red-theme', 'inverted');
    if (theme === 'red') header.classList.add('red-theme');
    else if (theme === 'inverted') header.classList.add('inverted');
  }

  /* Point the hero slide's data-theme at the image now showing, so the deck
     picks up the right colour when someone scrolls back to the hero. */
  function syncHeader(root, frame) {
    var slide = root.closest('.swiper-slide');
    if (!slide) return;
    if (!slide.hasAttribute('data-theme-default')) {
      slide.setAttribute('data-theme-default', slide.getAttribute('data-theme') || 'red');
    }
    var theme = (frame && frame.getAttribute('data-header-theme')) || slide.getAttribute('data-theme-default');
    if (slide.getAttribute('data-theme') === theme) return;
    slide.setAttribute('data-theme', theme);
    if (heroOnScreen(root)) paintHeader(theme);
  }

  function activeFrame(set) {
    return set ? set.querySelector('.hero-slideshow__frame.is-active') : null;
  }

  function advance(root) {
    if (document.hidden || reduce.matches || !heroOnScreen(root)) return;
    var set = visibleSet(root);
    if (!set) return;
    var frames = set.querySelectorAll('.hero-slideshow__frame');
    if (frames.length < 2) return;
    var cur = 0;
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].classList.contains('is-active')) { cur = i; break; }
    }
    var next = frames[(cur + 1) % frames.length];
    var img = next.querySelector('img');
    if (img && !(img.complete && img.naturalWidth)) return;
    frames[cur].classList.remove('is-active');
    next.classList.add('is-active');
    // Change the header halfway through the crossfade.
    var fade = parseInt(root.style.getPropertyValue('--hero-fade'), 10) || 1500;
    setTimeout(function () { syncHeader(root, next); }, fade / 2);
  }

  function init() {
    var roots = document.querySelectorAll('[data-hero-slideshow]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.hasAttribute('data-hero-ready')) continue;
      root.setAttribute('data-hero-ready', '');
      syncHeader(root, activeFrame(visibleSet(root)));
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      (function (r) { setInterval(function () { advance(r); }, interval); })(root);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
